<template>
    <div class="Servic nrk">
        <p>组织架构</p>
        <img src="img/zx-5.jpg" class="beij">
    </div>
</template>

<script>
export default {

}
</script>
<style scoped>
    .Servic img{
        width: 100%;
    }
</style>